import React from 'react';
import { HeartIcon, MapPinIcon } from 'lucide-react';
import { Stars } from '../Stars';
import { moreTestimonials } from '../../data/landing';
export function MoreTestimonials() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-177" data-mp="2bnwtsc7u8qv0">
      <div className="mx-auto mb-10 flex w-fit flex-col items-center gap-4 rounded-full bg-white px-6 py-3 shadow-sm sm:flex-row sm:gap-5" data-id="element-178" data-mp="2bmc16s533hzs">
        <div className="flex -space-x-3" aria-hidden="true" data-id="element-179" data-mp="22o0ayr84qm7v">
          {moreTestimonials.map(t => <span key={t.initials} className="flex h-10 w-10 items-center justify-center rounded-full bg-brand text-xs font-black text-white ring-2 ring-white" data-id="element-180" data-mp="1xx1spm3kze1z">
              {t.initials}
            </span>)}
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold text-xs font-black text-brand ring-2 ring-white" data-id="element-181" data-mp="1nyuaz11gwryx">
            +3k
          </span>
        </div>
        <div className="flex flex-col items-center sm:items-start" data-id="element-182" data-mp="1exw5eebdsce8">
          <div className="flex items-center gap-2" data-id="element-183" data-mp="1eypg1qdgnm1n">
            <Stars className="h-4 w-4" data-id="element-184" data-mp="3v91ag3x0ac4l" />
            <span className="text-sm font-black text-brand" data-id="element-185" data-mp="3v7zxtv0cdhkr">4.9/5</span>
          </div>
          <p className="text-sm font-semibold text-charcoal" data-id="element-186" data-mp="3w80hvie9ubz">
            +3.000 personas ya comen sin miedo
          </p>
        </div>
      </div>
      <h2 className="flex items-center justify-center gap-3 text-center text-3xl font-black uppercase tracking-tight text-brand md:text-5xl" style={{
      textAlign: "left",
      alignItems: "center",
      justifyContent: "center"
    }} data-id="element-187" data-mp="3qa7yifxdat6j">
          <HeartIcon className="h-8 w-8 shrink-0 fill-danger text-danger" aria-hidden="true" data-id="element-188" data-mp="mtrbv5sbrp1k" />
          Más personas que ya lo tienen
        </h2><div className="mx-auto max-w-6xl" data-id="element-189" data-mp="8tgk80j6y6fc">
        
        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-190" data-mp="cusc6cpjf3qp">
          {moreTestimonials.map(t => <figure key={t.author} className="flex flex-col rounded-3xl bg-white p-7 shadow-sm" data-id="element-191" data-mp="2tk79qgx00cp8">
              <div className="flex items-center gap-4" data-id="element-192" data-mp="2xlapl3f1q8qg">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand text-base font-black text-white" data-id="element-193" data-mp="2xn3v2fdxamwv">
                  {t.initials}
                </span>
                <div data-id="element-194" data-mp="z48unv25v93s">
                  <p className="font-extrabold text-brand" data-id="element-195" data-mp="z5to1hcqom02">{t.author}</p>
                  <p className="flex flex-wrap items-center gap-x-2 text-sm text-muted" data-id="element-196" data-mp="ubfqp9eio4sr">
                    <span className="flex items-center gap-1" data-id="element-197" data-mp="pd5ucvh22y5k">
                      <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-198" data-mp="lc2cy4jd0u28" /> {t.city}
                    </span>
                    <span aria-hidden="true" data-id="element-199" data-mp="gczkrkohaibo">·</span>
                    {t.tag}
                  </p>
                </div>
              </div>
              <div className="mt-5" data-id="element-200" data-mp="beejrj1ejum6">
                <Stars data-id="element-201" data-mp="6fbf3zpc3qeq" />
              </div>
              <blockquote className="mt-3 text-lg leading-relaxed text-charcoal" data-id="element-202" data-mp="6gmhbv34sq3q">“{t.quote}”</blockquote>
            </figure>)}
        </div>
      </div>
    </section>;
}